import {
  getTypeOfUser,
  ServiceTypes,
  TypeOfUser,
  UmbrellaUserTypes,
} from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';

import { useAppSelector } from '../useAppSelector';
import strings from '../../localization';

const { pharmacist, student, technician } = TypeOfUser;

const { self, full } = ServiceTypes;

const professionals = [pharmacist, student, technician];

const useProfessional = () => {
  const userType = useAppSelector(getTypeOfUser);
  const serviceType = ServiceHandler.getService();

  const isSelfService = serviceType === self;
  const isProfessional = professionals.includes(userType);

  const selfUserType = isProfessional && isSelfService
    ? UmbrellaUserTypes.professional
    : (userType as Exclude<TypeOfUser.admin, TypeOfUser>);

  const config = {
    [full]: {
      clientLabel: strings.pharmacist,
    },
    [self]: {
      clientLabel: strings.professional,
    },
  };

  return { isProfessional, selfUserType, ...config[serviceType] };
};

export default useProfessional;
